<template>
  <div class="user_content_blcok">
    <div
      class="user_content_blcok_title"
      style="position: relative;"
    >
      {{ lang.basic_info }}
    </div>
    <div class="admin_form_main">
      <el-form
        label-width="58px"
        ref="info"
        label-position="left"
        :hide-required-asterisk="true"
      >
        <el-form-item
          :label="`${ lang.avatar }：`"
          prop="avatar"
        >
          <el-upload
            class="avatar-uploader"
            action=""
            :auto-upload="false"
            :show-file-list="false"
            accept=".jpg,.png"
            :before-upload="beforeUpload"
            :on-change="handleUpload"
          >
            <img
              v-if="info.photo"
              :src="info.photo"
              class="avatar-upload"
            >
            <i
              v-else
              class="el-icon-plus avatar-uploader-icon"
            ></i>
          </el-upload>
        </el-form-item>
        <el-form-item :label="`${ lang.nickname }：`">
          <el-input
            :placeholder="lang.nickname_tips"
            v-model="info.nickname"
            @input="isPost = true"
          ></el-input>
        </el-form-item>
        <el-form-item
          :label="`${ lang.sex }：`"
          prop="gender"
          class="red_radio"
        >
          <el-radio-group
            v-model="info.sex"
            @change="isPost = true"
          >
            <el-radio :label="0">{{ lang.unknown }}</el-radio>
            <el-radio :label="1">{{ lang.male }}</el-radio>
            <el-radio :label="2">{{ lang.female }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <div class="user_content_blcok_line"></div>
        <div
          class="user_content_blcok_title"
          style="position: relative;"
        >
          {{ lang.security_settings }}
        </div>
      </el-form>
      <el-form
        label-width="90px"
        ref="info"
        label-position="left"
        :hide-required-asterisk="true"
        style="padding: 30px 0 40px"
      >
        <el-form-item :label="`${ lang.user_account }：`">
          <div class="setting-box">
            <span>{{ info.id }}</span>
          </div>
        </el-form-item>
        <el-form-item :label="`${ lang.login_pwd }：`">
          <div class="setting-box">
            <span>********</span>
            <div
              class="link-btn"
              @click="showPwdDialog = true"
            >{{ lang.edit_pwd }}</div>
          </div>
        </el-form-item>
        <el-form-item :label="`${ lang.phone }：`">
          <div class="setting-box">
            <span>{{ info.phone }}</span>
            <div
              class="link-btn"
              @click="changePhoneDialog = true"
            >{{ lang.change_tie }}</div>
          </div>
        </el-form-item>
      </el-form>
      <el-button
        type="warning"
        class="default-button"
        @click="editInfo"
      >{{ lang.save }}</el-button>
    </div>
    <el-dialog
      :title="lang.reset_pwd"
      :visible.sync="showPwdDialog"
      width="380px"
    >
      <div class="user-form">
        <div class="input-box">
          <input
            v-model="user.phone"
            disabled
            type="text"
            :placeholder="lang.phone_tips"
          >
        </div>
        <div class="input-box">
          <input
            v-model="params.code"
            type="text"
            :placeholder="lang.code"
          >
          <div
            v-show="showCode"
            class="btn"
            @click="getCode(user.phone, user.phoneprefix, 'a4')"
          >{{ lang.get_code }}</div>
          <div
            v-show="!showCode"
            class="btn disabled"
          >{{ lang.sent }}{{ count }}s</div>
        </div>
        <div class="input-box">
          <input
            v-model="params.loginpwd"
            type="password"
            :placeholder="lang.pwd"
          >
        </div>
        <div class="input-box">
          <input
            v-model="params.confirmPwd"
            type="password"
            :placeholder="lang.confirm_pwd"
          >
        </div>
        <div
          class="submit-btn"
          @click="handleResetPwd"
        >{{ lang.reset_pwd }}</div>
        <div class="tips">
          {{ lang.protocol_text1 }}<router-link to="/parse?key=loginuserkey">{{ lang.protocol_text2 }}</router-link>{{ lang.protocol_text3 }}<router-link to="/parse?key=loginuserPrivacykey">{{ lang.protocol_text4 }}</router-link>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      :title="lang.change_tie_phone"
      :visible.sync="changePhoneDialog"
      width="380px"
    >
      <div class="user-form">
        <template v-if="step === 1">
          <div class="input-box">
            <input
              v-model="user.phone"
              disabled
              type="text"
              :placeholder="lang.your_phone_tips"
            >
          </div>
          <div class="input-box">
            <input
              v-model="params.code"
              type="text"
              :placeholder="lang.code"
            >
            <div
              v-show="showCode"
              class="btn"
              @click="getCode(user.phone, user.phoneprefix, 'a3')"
            >{{ lang.get_code }}</div>
            <div
              v-show="!showCode"
              class="btn disabled"
            >{{ lang.sent }}{{ count }}s</div>
          </div>
        </template>
        <template v-if="step === 2">
          <div class="input-box">
            <div class="phone-code">
              <select v-model="params.phoneprefix">
                <option value="853">853</option>
                <option value="86">86</option>
              </select>
            </div>
            <input
              v-model="params.phone"
              type="text"
              :placeholder="lang.your_phone_tips"
            >
          </div>
          <div class="input-box">
            <input
              v-model="params.code"
              type="text"
              :placeholder="lang.code"
            >
            <div
              v-show="showCode"
              class="btn"
              @click="getCode(params.phone, params.phoneprefix, 'a3')"
            >{{ lang.get_code }}</div>
            <div
              v-show="!showCode"
              class="btn disabled"
            >{{ lang.sent }}{{ count }}s</div>
          </div>
        </template>
        <div
          v-if="step === 1"
          v-loading="loading"
          class="submit-btn"
          @click="handleNextStep"
        >{{ lang.next_step }}</div>
        <div
          v-else
          class="submit-btn back"
          @click="step = 1"
        >{{ lang.previous }}</div>
        <div
          v-if="step === 2"
          class="submit-btn"
          @click="changePhone"
        >{{ lang.confirm_text }}</div>
        <div class="tips">
          {{ lang.protocol_text1 }}<router-link to="/parse?key=loginuserkey">{{ lang.protocol_text2 }}</router-link>{{ lang.protocol_text3 }}<router-link to="/parse?key=loginuserPrivacykey">{{ lang.protocol_text4 }}</router-link>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { edituser, checkoldphone, editphone } from '@/api/user';
import { uploadFile, sendmsg } from '@/api/home';
import { rechargeloginpwd } from '@/api/login';
export default {
  components: {},
  props: {},
  data() {
    return {
      info: {},
      isPost: false,
      showPwdDialog: false,
      changePhoneDialog: false,
      params: {
        loginpwd: '',
        code: '',
        phoneprefix: '853',
        confirmPwd: ''
      },
      showCode: true,
      count: 60,
      timer: null,
      step: 1,
      loading: false
    };
  },
  computed: {
    lang() {
      return this.$t('member_info');
    },
    ...mapGetters(['user'])
  },
  mounted() {
    this.info = JSON.parse(JSON.stringify(this.user));
  },
  methods: {
    // 更换手机
    changePhone() {
      if (this.params.phoneprefix === '853') {
        if (!this.$macao_phone.test(this.params.phone)) {
          this.$message.error(this.lang.phone_check_tips);
          return;
        }
      } else {
        if (!this.$phone_str.test(this.params.phone)) {
          this.$message.error(this.lang.phone_check_tips);
          return;
        }
      }
      if (!this.params.code) {
        this.$message.error(this.lang.code_tips);
        return;
      }
      editphone({
        phoneprefix: this.params.phoneprefix,
        phone: this.params.phone,
        code: this.params.code
      }).then((res) => {
        if (res.code === 1) {
          this.changePhoneDialog = false
          this.$message.success(res.msg);
          this.$store.dispatch('updateUserInfo');
        }
      });
    },
    // 下一步
    handleNextStep() {
      if (!this.params.code) {
        this.$message.error(this.lang.code_tips);
        return;
      }
      this.loading = true;
      checkoldphone({
        phone: this.user.phone,
        code: this.params.code
      }).then((res) => {
        this.loading = false;
        if (res.code === 1) {
          this.params.code = '';
          this.step = 2;
        }
      });
    },
    // 重置密码
    handleResetPwd() {
      if (!this.params.code) {
        this.$message.error(this.lang.code_tips);
        return;
      }
      if (!this.params.loginpwd) {
        this.$message.error(this.lang.pwd_tips);
        return;
      }
      if (!this.params.confirmPwd) {
        this.$message.error(this.lang.pwd_confirm_tips);
        return;
      }
      if (this.params.confirmPwd !== this.params.loginpwd) {
        this.$message.error(this.lang.pwd_confirm_check_tips);
        return;
      }
      rechargeloginpwd({
        phone: this.user.phone,
        code: this.params.code,
        loginpwd: this.params.loginpwd
      }).then((res) => {
        this.showPwdDialog = false;
        this.$store.dispatch('logout');
        if (res.code === 1) {
          this.$alert(this.lang.tips_content, this.lang.tips, {
            confirmButtonText: this.lang.confirm_text,
            callback: (action) => {
              this.$router.push('/login');
            }
          });
        }
      });
    },
    // 获取验证吗
    async getCode(phone, phoneprefix, tempcode) {
      if (!phone) {
        this.$message.error(this.lang.phone_tips);
        return;
      }
      if (phoneprefix === '853') {
        if (!this.$macao_phone.test(phone)) {
          this.$message.error(this.lang.phone_check_tips);
          return;
        }
      } else {
        if (!this.$phone_str.test(phone)) {
          this.$message.error(this.lang.phone_check_tips);
          return;
        }
      }
      const { data } = await sendmsg({
        phoneprefix: phoneprefix,
        phone: phone,
        tempcode: tempcode
      });
      console.log(data);
      // 验证码倒计时
      if (!this.timer) {
        this.count = 60;
        this.showCode = false;
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= 60) {
            this.count--;
          } else {
            this.showCode = true;
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }
    },
    // 上传图片
    handleUpload(e) {
      uploadFile({
        file: e.raw
      }).then(({ data }) => {
        this.isPost = true;
        this.info.photo = data.accessAddress;
      });
    },
    beforeUpload(file) {
      const imgType = ['image/jpeg', 'image/jpg', 'image/png'];
      const isType = imgType.includes(file.type);
      if (!isType) {
        this.$message.error(this.lang.upload_tips);
      }
      return isType;
    },
    // 保存
    editInfo() {
      if (!this.isPost) return;
      edituser({
        headimgurl: this.info.photo,
        nickName: this.info.nickname,
        sex: this.info.sex
      }).then((res) => {
        if (res.code === 1) {
          this.isPost = false;
          this.$store.dispatch('updateUserInfo');
          this.$message.success(res.msg);
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.admin_form_main {
  padding-top: 30px;
}
.setting-box {
  display: flex;
  span {
    width: 200px;
    color: #4f4f4f;
    font-size: 14px;
  }
  .link-btn {
    color: #ec9221;
    font-size: 14px;
    cursor: pointer;
  }
}
.avatar-upload {
  width: 80px;
  height: 80px;
}
/deep/ .el-dialog__header {
  text-align: center;
}
/deep/ .el-dialog__headerbtn {
  display: none;
}
/deep/ .el-dialog__body {
  padding: 30px;
}
.user-form {
  .input-box {
    display: flex;
    align-items: center;
    width: 290px;
    height: 36px;
    background: #f1f4f9;
    border-radius: 4px;
    margin-bottom: 30px;
    padding: 0 15px;
    select {
      position: relative;
      background: #f1f4f9;
      border: 0;
      margin-right: 20px;
      outline: none;
    }
    input {
      flex: 1;
      background: #f1f4f9;
      border: 0;
      outline: none;
      font-size: 14px;
      margin-right: 20px;
    }
    .btn {
      cursor: pointer;
      color: #ec9221;
      &.disabled {
        color: #aaa;
      }
    }
  }
  .submit-btn {
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 320px;
    height: 38px;
    background: #ec9221;
    border-radius: 4px;
    color: #fff;
    font-size: 14px;

    border: 1px solid #ec9221;
    margin-bottom: 20px;
    &.back {
      background: #fff;
      color: #ec9221;
    }
  }
  .tips {
    padding-top: 20px;
    font-size: 13px;
    color: #4f4f4f;
    a {
      color: #ec9221;
    }
  }
}
::placeholder {
  color: #aaa;
}
</style>